import type { Tag } from '@modules/libraries/store/types';
import { IS_SHOW_ALL_TEMPLATE } from '@/modules/libraries/store/config';

/**
 * Function to fetch & update data of an array.
 * @example FETCH(state.list, list, ()
 * @param {Array<Object>} array original array
 * @param {Array<Object>} list append array
 * @param {Function<Object, Object>} comparer Comparator to find item
 * @param {Function<Object>} tranformer Expression to transform item data.
 */
export const FETCH = (
  array: any[],
  list: any[],
  comparer: (arg0: any, arg1: any) => any,
  tranformer: ((arg0: any) => any | undefined) | null | undefined,
) => {
  if (!list || !list.length) return;
  if (JSON.stringify(array) !== JSON.stringify(list)) {
    const union: { item: any; index: number | null }[] = [];
    /**
     * find
     * @param item ..
     * @returns object or undefined
     */
    const find = (item: any) => {
      if (comparer) {
        const found = array.findIndex((obj) => {
          return comparer(obj, item);
        });
        return found;
      }
      return null;
    };

    list.forEach((item) => {
      if (typeof tranformer == 'function') {
        item = tranformer(item);
      }
      const index = find(item);
      if (index != null && index >= 0) {
        union.push({
          item: item,
          index: index,
        });
      } else {
        array.push(item);
      }
    });
    if (union.length > 0) {
      union.forEach((uno) => {
        if (uno.index != null) {
          array.splice(uno.index, 1, uno.item);
        }
      });
    }
  }
};

export const generateTagWithCount = (tag: any, searchString: string) => {
  if (!tag.children) {
    return {
      id: tag.id,
      name: tag.name,
      handle: tag.handle,
      children: [],
      count: (searchString.match(new RegExp(`-${tag.id}-`, 'g')) || []).length,
    };
  }

  return {
    id: tag.id,
    name: tag.name,
    handle: tag.handle,
    children: tag.children.map((childTag: any) => {
      return generateTagWithCount(childTag, searchString);
    }),
    count: (searchString.match(new RegExp(`-${tag.id}-`, 'g')) || []).length,
  };
};

export const getUseCaseInfo = (tag: any, pageType: string, templates: any) => {
  const isCheckPageType = (currentTemplate: any) => {
    if (IS_SHOW_ALL_TEMPLATE) {
      return true;
    }
    return currentTemplate.tags.includes(pageType);
  };
  if (!tag.children) {
    const count = templates.reduce((previous: number, currentTemplate: any) => {
      const count = currentTemplate.use_cases.includes(tag.handle) && isCheckPageType(currentTemplate) ? 1 : 0;
      return (previous += count);
    }, 0);

    if (count === 0) {
      return null;
    }

    return {
      id: tag.id,
      name: tag.name,
      handle: tag.handle,
      children: [],
      count,
    };
  }

  const children: Tag[] = [];
  tag.children.forEach((childTag: any) => {
    const useCase = getUseCaseInfo(childTag, pageType, templates);
    if (useCase) {
      children.push(useCase);
    }
  });

  return {
    id: tag.id,
    name: tag.name,
    handle: tag.handle,
    children,
    count: templates.reduce((previous: number, currentTemplate: any) => {
      const count = currentTemplate.use_cases.includes(tag.handle) && isCheckPageType(currentTemplate) ? 1 : 0;
      return (previous += count);
    }, 0),
  };
};
